import styled from "styled-components";

export const ModalBody = styled.div`
  text-align: center;
`;

export const Icone = styled.div`
  margin: auto;
  font-size: 50px;

  svg {
    background-color: #fff5eb;
    color: #fe8f14;
    border-radius: 10px;
    padding: 12px;
  }
`;

export const ContainerTextos = styled.div`
  text-align: left;
  margin-top: 12px;
`;
